import React, { useState } from 'react';
import { GiHamburgerMenu } from 'react-icons/gi';
import { MdOutlineRestaurantMenu } from 'react-icons/md';
import './Navbar.css';

import images from '../../constants/images';

const Navbar = () => {
  const [toggleMenu, setToggleMenu] = useState(false);

  const handleMenuItemClick = () => {
    setToggleMenu(false);
  };

  return (
    <nav className='app__navbar'>
      <div className='app__navbar-logo'>
        <a href='/'><img src={images.nyLogo} alt='app logo' /></a>
      </div>

      <a
  href='https://chipotlemexicansteak.orderyoyo.com/'
  className='mobile-order-btn'
>
  BESTIL MAD ONLINE
</a>



      <ul className='app__navbar-links'>

        <li className='p__opensans2'><a href='#home'>HJEM</a> </li>

        <li className='p__opensans2'><a href='#about'>OM</a> </li>
        <li className='p__opensans2'><a href='#menu'>MENU</a> </li>
        <li className='p__opensans2'><a href='#chef'>BOOK BORD</a> </li>
        <li className='p__opensans2'><a href='#contact'>KONTAKT</a> </li>
        <li
  className='p__opensans2'
  style={{
    border: '2px solid #dcca87',
    borderRadius: '10px',
    padding: '8px 14px',
    display: 'inline-block',
  }}
>
  <a
    href='https://chipotlemexicansteak.orderyoyo.com/'
    style={{
      color: '#dcca87',
      fontWeight: '700',
      textDecoration: 'none',
      whiteSpace: 'nowrap',
    }}
  >
    BESTIL MAD ONLINE
  </a>
</li>
      </ul>

  
      <div className='app__navbar-smallscreen'>
        <GiHamburgerMenu color='#fff' fontSize={27} onClick={() => setToggleMenu(true)} />
        {toggleMenu && (
          <div className='app__navbar-smallscreen_overlay flex__center slide-bottom'>
            <MdOutlineRestaurantMenu fontSize={27} className='overlay__close' onClick={() => setToggleMenu(false)} />
            <ul className='app__navbar-smallscreen_links'>
              <li className='p__opensans2'><a href='#home' onClick={handleMenuItemClick}>HJEM</a> </li>
              <li className='p__opensans2'><a href='https://chipotlemexicansteak.orderyoyo.com/' onClick={handleMenuItemClick}>BESTIL MAD ONLINE</a> </li>

              <li className='p__opensans2'><a href='#about' onClick={handleMenuItemClick}>OM</a> </li>
              <li className='p__opensans2'><a href='#menu' onClick={handleMenuItemClick}>MENU</a> </li>
              <li className='p__opensans2'><a href='#chef' onClick={handleMenuItemClick}>BOOK BORD</a> </li>
              <li className='p__opensans2'><a href='#contact' onClick={handleMenuItemClick}>KONTAKT</a> </li>

              <li
  className='p__opensans2'
  style={{
    background: '#dcca87',
    borderRadius: '10px',
    padding: '10px 18px',
    margin: '12px 0',
    display: 'inline-block',
    boxShadow: '0 4px 12px rgba(0,0,0,.25)',
  }}
>
  <a
    href='https://chipotlemexicansteak.orderyoyo.com/'
    onClick={handleMenuItemClick}
    style={{
      color: '#0c0c0c',
      fontWeight: '700',
      textDecoration: 'none',
      display: 'block',
    }}
  >
    BESTIL MAD ONLINE
  </a>
</li>
            </ul>
          </div>
        )}
      </div>
    </nav>
  );
}

export default Navbar;
